// extracted by mini-css-extract-plugin
export default {"largeInput":"style-module--largeInput--QzLpy","button":"style-module--button--igdZx"};